import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  itemCategoriesEdit: {},
  isLoading: false,
  showDialog: false,
};

//STORE SLICE
export const itemCategoriesEditSlice = createSlice({
  name: "itemCategoriesEditSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showEditItemCategoriesDialog(state, action) {
      return {
        ...state,
        showDialog: true,
        itemCategoriesEdit: action.payload,
      };
    },
    closeEditItemCategoriesDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showEditItemCategoriesDialog,
  closeEditItemCategoriesDialog,
  showLoading,
  hideLoading
} = itemCategoriesEditSlice.actions;

export default itemCategoriesEditSlice.reducer;
